module.exports = __webpack_public_path__ + "assets/d697abd346b57baaaa3c64733e998c6a.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-cyrillic-ext-500-normal.woff2
// module id = 2624
// module chunks = 121